/* eslint-disable import/prefer-default-export */
import config from '../../../config';

export const getConfigValue = key => $.get(`${config.api}/configs/${key}`);



// WEBPACK FOOTER //
// ./src/Common/Providers/ConfigsApi.js